"use client";

import { getAuthToken } from "@dynamic-labs/sdk-react-core";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import { type Referral } from "../../firebase/firebase.types";
import { redeemReferral } from "../referrals.service";

type RedeemReferralPayload = {
  code: string;
};

export const useRedeemReferral = (
  options?: UseMutationOptions<Referral, Error, RedeemReferralPayload>,
) =>
  useMutation({
    ...options,
    mutationFn: async ({ code }) => {
      const token = getAuthToken();

      if (!token) {
        throw new Error("Authorization token not available");
      }

      const result = await redeemReferral({ token, code });

      if (result.error) {
        throw new Error(result.error.message);
      }

      return result.data;
    },
  });
